import React, {useEffect, useState} from "react";
import Images from "../../assets/images/images";
import Row from "../UI/Row";
import {MdClose} from "react-icons/md";
import {BiMenu} from "react-icons/bi";
import BurgerLink from "./BurgerLink";
import NavLink from "./NavLink";
import {useLocation} from "react-router-dom";
import {FaUser} from "react-icons/fa";

const Header = ({current}) => {

    const { pathname } = useLocation();

    const [menuOpen, setMenuOpen] = useState(false);
    const [isLogged, setIsLogged] = useState(false);

    const goToHome = () => {
        window.location.href = process.env.REACT_APP_WEBSITE_DOMAIN;
    }

    useEffect(() => {
        const load = () => {
            let token = sessionStorage.getItem('@user_token');
            if(token) {
                setIsLogged(true);
            } else {
                setIsLogged(false);
            }
        }
        load();
    }, [pathname]);

    return (
        <div
            className="sticky top-0  w-full shadow-xl z-20">
            <div className="flex flex-row justify-center px-4 bg-gradient-to-r from-ea_green_from to-ea_green_to">
                <div className="w-full flex flex-row justify-between items-center md:items-start" style={{maxWidth: "1200px"}}>
                    <div className="flex flex-col items-center justify-center cursor-pointer" title="Torna alla Home"
                         onClick={goToHome}>
                        <img src={Images.headerLogo} alt="logo" className="h-12 my-2 md:h-12"/>
                    </div>
                    <Row className="text-white gap-8 hidden md:flex">
                        <NavLink to="/" current={current}>Home</NavLink>
                        <NavLink to="/pacchetti/" current={current}>Pacchetti</NavLink>
                        <NavLink to="/funzionalita-preventivo/" current={current}>Funzionalità</NavLink>
                        <NavLink to="/app/signup" current={current}>Prova GRATIS</NavLink>
                        <NavLink to="/app/dashboard" current={current}><Row className="items-center gap-1">Area riservata <FaUser /></Row></NavLink>
                    </Row>

                    <div onClick={() => setMenuOpen(!menuOpen)} className="block md:hidden text-2xl cursor-pointer text-white">
                        {menuOpen ?
                            <MdClose/>
                            :
                            <BiMenu />}
                    </div>
                </div>
            </div>
            {menuOpen && <div className="bg-white w-full ">
                <BurgerLink current={current} to="/">Home</BurgerLink>
                <BurgerLink current={current} to="/pacchetti/">Pacchetti</BurgerLink>
                <BurgerLink current={current} to="/funzionalita-preventivo/">Funzionalità</BurgerLink>
                <BurgerLink current={current} to="/app/signup" >Prova GRATIS</BurgerLink>
                <BurgerLink current={current} to="/app/dashboard"><Row className="items-center justify-center gap-1">Area riservata <FaUser /></Row></BurgerLink>
                {/*<BurgerLink current={current} to="/app/login">Accedi</BurgerLink>*/}
            </div>}

        </div>
    );
}

export default Header;
